import {DialogController} from "./dialogs";

(() => {
	const dialog = document.getElementById("whitepaper-forms-dialog");
	if (!(dialog instanceof HTMLDialogElement)) {
		return;
	}

	let shouldAttach = true;
	const disconnectAnchors = () => {
		shouldAttach = false;
		mutationObserver.disconnect();
		for (const anchor of document.querySelectorAll<HTMLAnchorElement>("a.whitepaper-interceptor-setup")) {
			anchor.removeEventListener('click', handleWhitepaperAnchorClick);
		}
	};
	const performDownload = async (href: string, errorHandler: (resp: Response) => void) => {
		dialogController.show("whitepaper-forms-waiting");
		const resp = await fetch(dialog.getAttribute("data-endpoint-perform-download")!, {
			method: 'POST',
			body: new URLSearchParams({email_address: getCookie() ?? '', requested_whitepaper: href})
		});
		if (!resp.ok) {
			errorHandler(resp);
			return;
		}
		const {status} = await resp.json() as {status: Status};

		switch (status) {
			case "UNSET":
				dialogController.show(dialogController.askedForEmail ? "lets-get-to-know-you-better" : "do-we-know-you");
				break;
			case "UNCONFIRMED":
				dialogController.show("please-check-your-email");
				break;
			case "CONFIRMED":
				disconnectAnchors();
				dialogController.show("can-download-immediately");
				break;
		}
	}
	const dialogController = new DialogController(dialog, disconnectAnchors, performDownload);

	const handleWhitepaperAnchorClick = async (e: MouseEvent) => {
		const anchor = e.target instanceof HTMLAnchorElement ? e.target : e.currentTarget;
		if (anchor instanceof HTMLAnchorElement) {
			e.preventDefault();
			e.stopPropagation();

			if (!getCookie()) {
				dialogController.begin("do-we-know-you", anchor.href);
				return;
			}
			dialogController.begin("whitepaper-forms-waiting", anchor.href);
			await performDownload(anchor.href, resp => {
				//TODO: Handle errors
			});
		}
	}

	const mutationObserver = new MutationObserver(mutations => {
		for (const mutation of mutations) {
			for (const mutationRootNode of mutation.addedNodes) {
				if (mutationRootNode instanceof HTMLAnchorElement) {
					if (mutationRootNode.href.includes("/whitepaper/") && !mutationRootNode.href.endsWith("/whitepaper/")) {
						mutationRootNode.classList.add("whitepaper-interceptor-setup");
						mutationRootNode.addEventListener('click', handleWhitepaperAnchorClick);
					}
				} else if (mutationRootNode instanceof Element) {
					for (const anchor of mutationRootNode.querySelectorAll<HTMLAnchorElement>("a[href*='/whitepaper/']:not(.whitepaper-interceptor-setup[href$='/whitepaper/'])")) {
						anchor.classList.add("whitepaper-interceptor-setup");
						anchor.addEventListener('click', handleWhitepaperAnchorClick);
					}
				}
			}
		}
	});
	const wireUpAnchors = () => {
		if (!shouldAttach) {
			return;
		}
		for (const anchor of document.querySelectorAll<HTMLAnchorElement>("a[href*='/whitepaper/']:not(.whitepaper-interceptor-setup[href$='/whitepaper/'])")) {
			anchor.classList.add("whitepaper-interceptor-setup");
			anchor.addEventListener('click', handleWhitepaperAnchorClick);
		}
		mutationObserver.observe(document.body, {subtree: true, childList: true});
	};

	if (document.readyState === "loading") {
		document.addEventListener('DOMContentLoaded', wireUpAnchors);
	} else {
		wireUpAnchors();
	}

	document.addEventListener('DOMContentLoaded', () => {
		// If the cookie has been set and there are whitepaper links on the page, we check whether the user has download permissions preemptively
		// This is done purely for UX purposes, and can be removed if needed
		if (getCookie() && document.querySelector("a[href*='/whitepaper/']:not([href$='/whitepaper/'])")) {
			checkStatus(dialog).then(status => {
				if (status === 'CONFIRMED') {
					disconnectAnchors();
				}
			});
		}
	});
})();

export function getCookie() {
	const parts = `; ${document.cookie}`.split(`; horton-marketing-email=`);
	return parts.length === 2 ? parts.pop()!.split(';').shift()! : undefined;
}
export function setCookie(email: string) {
	document.cookie = `horton-marketing-email=${email}; max-age=2592000; Secure; path=/`; // Make it last for 30 days
}
export type Status = 'UNSET'|'UNCONFIRMED'|'CONFIRMED';
export function checkStatus(dialog: HTMLDialogElement) {
	return fetch(dialog.getAttribute("data-endpoint-check-status")!, {method: 'POST', body: new URLSearchParams({email_address: getCookie() ?? '', })})
		.then(resp => resp.json())
		.then((resp: {status: Status}) => resp.status)
		.catch(() => {
			document.cookie = "horton-marketing-email=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT";
			return "UNSET";
		});
}
